import React from 'react';
import styled from 'styled-components';
import { Link, useHistory } from 'react-router-dom';
import { Menu } from 'semantic-ui-react';

const CityLogo = styled.img`
  width: 30px;
  height: auto;
`;

const HeaderLabel = styled(Menu.Item)`
  &&& {
    font-weight: bold;
    font-size: 15px;
    padding: 0;
  }
`;


const HeaderItem = styled.div`
  font-size: 14px;
  font-weight: bold;
  line-height: 1.29;
  color: #000000;
`;

export const PageBanner = () => {
  return (
    <>
      <Menu
        borderless
        fixed="top"
        size="small"
        // This is to cover the Material UI Modal (z-index 10)
        style={{ zIndex: 11 }}
      >
        <Menu.Item as={Link} to="/" header>
          <CityLogo
            src="https://placer-ca-str.dev.deckard.com/assets/Placer-County.png"
            alt="Placer Logo"
          />
        </Menu.Item>

        <HeaderLabel>Placer County Online Assessment Payment</HeaderLabel>
      </Menu>
      <div style={{ height: 50 }} />
    </>
  );
}

export function HelpBanner(props) {
  const { handleMenuClick } = props;

  const history = useHistory();

  return (
    <Menu
      borderless
      fixed="top"
      size="small"
      // This is to cover the Help Modal (z-index 12)
      style={{ zIndex: 13 }}
    >
      <Menu.Item header style={{ cursor: 'pointer' }}>
        <HeaderItem onClick={history.goBack}>Back</HeaderItem>
      </Menu.Item>

      <Menu.Menu position="right">
        <Menu.Item style={{ cursor: 'pointer' }}>
          <HeaderItem onClick={handleMenuClick}>Menu</HeaderItem>
        </Menu.Item>
      </Menu.Menu>
    </Menu>

  );
}
